import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { useDetailStore } from '../../hooks';
import { MenuCategoryEditResultModalView } from './MenuCategoryEditResultModalView';
import { MenuCategoryEditConfirmModalView } from './MenuCategoryEditConfirmModalView';
import { MenuCategoryEditInputModalView } from './MenuCategoryEditInputModalView';

type Props = ReturnType<typeof useDetailStore>;

export const MenuCategoryModalView: FC<Props> = ({
  isOpenModal,
  currentModalStep,
  onCloseModal,
  onCloseModalWhenCompleted,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  canDelete,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <MenuCategoryEditInputModalView
        {...form}
        values={values}
        handleConfirm={onConfirm}
        handleDeleteConfirm={onOpenModalDelete}
        canDelete={canDelete}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <MenuCategoryEditConfirmModalView
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <MenuCategoryEditResultModalView
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
